<div
  class="flex flex-col items-center justify-center pl-6 pr-6 pt-0 pb-0 gap-8 h-fit w-full max-w-[1536px] min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:pl-8 min-[1024px]:pr-8 min-[1024px]:gap-6"
>
  <!-- Heading -->
  <div
    class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
  >
    <h2
      class="text-[#161C23] font-bold text-[32px] leading-10 tracking-normal text-left h-fit w-fit min-[1024px]:text-5xl min-[1024px]:leading-[48px] min-[1024px]:w-full"
    >
      Technologies We Use
    </h2>
  </div>

  <!-- Description -->
  <div
    class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:w-[768px] min-[1024px]:max-w-[768px]"
  >
    <p
      class="text-[#474747] font-normal text-base leading-[26px] tracking-normal text-left h-fit w-fit min-[1024px]:text-xl min-[1024px]:leading-[32.5px] min-[1024px]:h-[98px] min-[1024px]:w-[741px]"
    >
      Even though we have some go-to technologies, we're never limited by them. Over the years,
      we've seen that different problems call for different approaches. So depending on the product,
      we pick the stack that makes the most sense.
    </p>
  </div>

  <!-- Categories Container -->
  <div
    class="flex flex-col items-center justify-center pt-4 pb-0 h-fit w-full max-w-[400px] gap-6 min-[1024px]:flex-row min-[1024px]:items-center min-[1024px]:justify-around min-[1024px]:pt-[41px] min-[1024px]:max-w-none"
  >
    @for (category of categories(); track category.name) {
      <!-- Mobile Card -->
      <div
        class="flex flex-col items-center justify-center bg-white pl-8 pr-8 pt-8 pb-8 rounded border border-[#C6C6C6] h-fit w-full gap-8 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] min-[1024px]:pl-12 min-[1024px]:pr-12 min-[1024px]:pt-12 min-[1024px]:pb-12 min-[1024px]:rounded-lg min-[1024px]:h-[334px] min-[1024px]:gap-10 min-[1024px]:max-w-[500px]"
      >
        <!-- Category Header -->
        <div class="flex flex-row items-center justify-start h-fit w-full">
          <div class="flex flex-col items-start justify-start h-fit w-full">
            <h3
              class="text-[#161C23] font-semibold text-2xl leading-8 tracking-normal text-left h-fit w-full min-[1024px]:text-3xl min-[1024px]:leading-9"
            >
              {{ category.name }}
            </h3>
          </div>
        </div>

        <!-- Mobile items: flex-wrap single container -->
        <div
          class="flex flex-wrap flex-row items-center justify-center h-fit w-full gap-2 min-[1024px]:hidden max-w-[576px]"
        >
          @for (item of category.items; track item) {
            <app-mini-card [logo]="item" class="w-[128px] h-[52px]"></app-mini-card>
          }
        </div>

        <!-- Desktop items: two rows of pairs -->
        <div
          class="hidden flex-row flex-wrap items-center justify-center h-fit w-full gap-6 min-[1024px]:flex max-w-[576px]"
        >
          @for (item of category.items; track item) {
            <app-mini-card [size]="'large'" [logo]="item" class="w-[154px] h-[70px]"></app-mini-card>
          }
        </div>
      </div>
    }
  </div>
</div>
